import React from 'react'
import Navbar from '../components/Navbar'
import Container from '@material-ui/core/Container'
import ExamsTabs from '../components/examsGeneralComponents/ExamsTabs'

const Exams = () => {

  return (
    <>
      <Navbar type="examBar"/>
      <Container fixed>
        <ExamsTabs />
      </Container>
    </>
  )
}

export default Exams